export default __webpack_public_path__ + "static/highlighter_tool_white.e8f8b573479271dcdcdef5e5b78d1e62.svg";